import type { Identifier } from 'fhir/r4';
import {
  type DiagnosticReportIdentifier,
  type IdentifierCode,
  type MigrationCode,
  type ServiceRequestIdentifier,
  system,
} from '../coding';

import { createCodeableConcept } from './coding';

export const createSystemIdentifier = (
  code: CreateIdentifierCode,
  value: string,
  systemUrl: string,
): Identifier => ({
  system: systemUrl,
  value,
  type: createCodeableConcept(code),
});

export const createIdentifier = (
  code: CreateIdentifierCode,
  value: string,
  systemUrl: string = system,
): Identifier => createSystemIdentifier(code, value, systemUrl);

type CreateIdentifierCode =
  | IdentifierCode
  | ServiceRequestIdentifier
  | DiagnosticReportIdentifier
  | MigrationCode;
